module.exports = __webpack_public_path__ + "media/images/example-check-2-eeecddde.png";